import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Pages/ErrorPage";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ErrorPageTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="ErrorPage">
      <TabletNotice page="ErrorPage" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default ErrorPageTablet;